(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[742],{

/***/ 84678:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/company",
      function () {
        return __webpack_require__(57373);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 57373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./packages/datasource/src/api/operation/index.js
var operation = __webpack_require__(89471);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/utils/index.js + 4 modules
var utils = __webpack_require__(59914);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/alert/index.js + 2 modules
var es_alert = __webpack_require__(90567);
;// CONCATENATED MODULE: ./src/pages/my/company/company.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 2rem;\n\n  a {\n    margin-left: 0.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid #e9eaee;\n  background-color: #e9eaee88;\n  border-radius: 12px;\n  color: #9f9f9f;\n  font-size: 12px;\n  font-weight: normal;\n  padding: 2px 8px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Alert = (0,styled_components_browser_esm/* default */.ZP)(es_alert/* default */.Z)(_templateObject());
var TitleBadge = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());

// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 14 modules
var modal = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(8289);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 44 modules
var es_select = __webpack_require__(18963);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 5 modules
var input = __webpack_require__(79531);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleOutlined.js + 1 modules
var ExclamationCircleOutlined = __webpack_require__(11475);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SafetyOutlined.js + 1 modules
var SafetyOutlined = __webpack_require__(2099);
// EXTERNAL MODULE: ./packages/datasource/src/index.js + 24 modules
var src = __webpack_require__(72579);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/my/company/form/form.styled.js
function form_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function form_styled_templateObject() {
    var data = form_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  a {\n    font-size: 12px;\n    margin-left: 1em;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    form_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function form_styled_templateObject1() {
    var data = form_styled_taggedTemplateLiteral([
        "\n  margin-top: .5rem;\n  color: ",
        ";\n"
    ]);
    form_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Label = styled_components_browser_esm/* default.div */.ZP.div(form_styled_templateObject(), mixins/* flexVerticalCenter */.VL(), colors.C4, colors.B1);
var Description = styled_components_browser_esm/* default.div */.ZP.div(form_styled_templateObject1(), colors.C4);

// EXTERNAL MODULE: ./src/api/me/index.ts
var me = __webpack_require__(12330);
// EXTERNAL MODULE: ./src/utils/form.utils.js
var form_utils = __webpack_require__(9716);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/pages/my/company/form/Form.component.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











var formData = (0,src/* getFormData */.zi)();
var personalPositions = formData.org.enums.personalPositions;
var FormComponent = function() {
    var ref10 = (0,react.useState)(false), isSubmitting = ref10[0], setIsSubmitting = ref10[1];
    var ref1 = (0,react.useState)(""), companyName = ref1[0], setCompanyName = ref1[1];
    var ref2 = (0,react.useState)(""), companyNameOther = ref2[0], setCompanyNameOther = ref2[1];
    var ref3 = (0,react.useState)(""), jobTitle = ref3[0], setJobTitle = ref3[1];
    var ref4 = (0,dist/* default */.ZP)("/api/profile", me/* profile */.N5), data = ref4.data, error = ref4.error, mutate = ref4.mutate;
    var isLoading = !error && !data;
    (0,react.useEffect)(function() {
        var ref, ref7;
        var ref8;
        setCompanyName((ref8 = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company_name) !== null && ref8 !== void 0 ? ref8 : "");
        var ref9;
        setJobTitle((ref9 = data === null || data === void 0 ? void 0 : (ref7 = data.data) === null || ref7 === void 0 ? void 0 : ref7.job_title) !== null && ref9 !== void 0 ? ref9 : "");
    }, [
        data
    ]);
    var handleSubmit = function() {
        var onOk = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsSubmitting(true);
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,me/* update */.Vx)({
                                company_name: companyName === "\u5176\u5B83" ? companyNameOther : companyName !== null && companyName !== void 0 ? companyName : "",
                                job_title: jobTitle !== null && jobTitle !== void 0 ? jobTitle : ""
                            });
                        case 4:
                            _ctx.next = 11;
                            break;
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](1);
                            console.error(_ctx.t0);
                            _ctx.next = 11;
                            return message/* default.success */.ZP.success("\u516C\u53F8\u4FE1\u606F\u66F4\u65B0\u5931\u8D25\uFF0C\u9519\u8BEF\u539F\u56E0\uFF1A", _ctx.t0);
                        case 11:
                            _ctx.next = 13;
                            return mutate();
                        case 13:
                            setIsSubmitting(false);
                            message/* default.success */.ZP.success("\u516C\u53F8\u4FE1\u606F\u66F4\u65B0\u6210\u529F");
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        6
                    ]
                ]);
            }));
            return function onOk() {
                return _ref.apply(this, arguments);
            };
        }();
        var status = data === null || data === void 0 ? void 0 : data.data.company_verified_status;
        if (status === me/* ECompanyVerifiedStatus.verified */.yn.verified) {
            modal/* default.confirm */.Z.confirm({
                title: "\u66F4\u65B0\u516C\u53F8\u4FE1\u606F",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationCircleOutlined/* default */.Z, {}),
                content: "\u66F4\u65B0\u516C\u53F8\u4FE1\u606F\u9700\u8981\u91CD\u65B0\u8FDB\u884C\u8BA4\u8BC1\uFF0C\u786E\u8BA4\u66F4\u65B0\u5417\uFF1F",
                okText: "\u786E\u8BA4",
                cancelText: "\u53D6\u6D88",
                onOk: onOk
            });
        } else {
            onOk();
        }
    };
    var fetchOptions = form_utils.fetchOrganizationOptions;
    var debounceTimeout = 800;
    var ref5 = (0,react.useState)(false), isFetching = ref5[0], setIsFetching = ref5[1];
    var ref6 = (0,react.useState)([]), options1 = ref6[0], setOptions = ref6[1];
    var fetchRef = (0,react.useRef)(0);
    var handleSearch = (0,react.useMemo)(function() {
        var loadOptions = function(value) {
            fetchRef.current += 1;
            var fetchId = fetchRef.current;
            setOptions([]);
            setIsFetching(true);
            fetchOptions(value).then(function(options) {
                // fetch is asynchronous, so the condition will make sure the
                // callback only updates for its own fetcher
                if (fetchId !== fetchRef.current) {
                    return;
                }
                setOptions(options.concat({
                    value: "\u5176\u5B83"
                }));
                setIsFetching(false);
            });
        };
        return debounce_default()(loadOptions, debounceTimeout);
    }, [
        fetchOptions
    ]);
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        active: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
        layout: "vertical",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                gutter: 32,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                        xs: 24,
                        md: 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                    children: "\u516C\u53F8\u540D\u79F0"
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                    allowClear: true,
                                    showSearch: true,
                                    filterOption: false,
                                    notFoundContent: isFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                        size: "small"
                                    }) : null,
                                    value: companyName === "" ? undefined : companyName,
                                    placeholder: "\u8BF7\u9009\u62E9\u6240\u5728\u7684\u516C\u53F8",
                                    maxLength: 128,
                                    onChange: function(value) {
                                        return setCompanyName(value);
                                    },
                                    onSearch: handleSearch,
                                    options: options1
                                })
                            }),
                            companyName === "\u5176\u5B83" && /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                    value: companyNameOther,
                                    onChange: function(event) {
                                        return setCompanyNameOther(event.target.value);
                                    },
                                    placeholder: "\u8BF7\u8F93\u5165\u6240\u5728\u7684\u516C\u53F8",
                                    maxLength: 128
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "\u804C\u4F4D",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                    allowClear: true,
                                    value: jobTitle === "" ? undefined : jobTitle,
                                    onChange: function(value) {
                                        return setJobTitle(value);
                                    },
                                    placeholder: "\u8BF7\u9009\u62E9",
                                    options: personalPositions
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "primary",
                                ghost: true,
                                htmlType: "submit",
                                size: "small",
                                // disabled={!R.isEmpty(errors)}
                                loading: isSubmitting,
                                onClick: handleSubmit,
                                children: "\u66F4\u65B0\u4FE1\u606F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        xs: 24,
                        md: 12
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Description, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SafetyOutlined/* default */.Z, {}),
                    " TiDB \u793E\u533A\u4FDD\u62A4\u4F60\u7684\u4E2A\u4EBA\u9690\u79C1\uFF0C\u6B64\u4FE1\u606F\u4E3A\u975E\u516C\u5F00\u72B6\u6001"
                ]
            })
        ]
    });
};
/* harmony default export */ var Form_component = (FormComponent);

;// CONCATENATED MODULE: ./src/pages/my/company/form/index.js


// EXTERNAL MODULE: ./src/pages/my/layout/index.js + 5 modules
var layout = __webpack_require__(35703);
// EXTERNAL MODULE: ./node_modules/antd/es/space/index.js + 1 modules
var space = __webpack_require__(26713);
;// CONCATENATED MODULE: ./src/pages/my/company/Verification.styled.js
function Verification_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Verification_styled_templateObject() {
    var data = Verification_styled_taggedTemplateLiteral([
        "\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid ",
        ";\n"
    ]);
    Verification_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Verification_styled_templateObject1() {
    var data = Verification_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  a {\n    color: ",
        ";\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    Verification_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Verification_styled_taggedTemplateLiteral([
        "\n  margin: 1rem 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm/* default.div */.ZP.div(Verification_styled_templateObject(), colors.C2);
var Verification_styled_Description = styled_components_browser_esm/* default.div */.ZP.div(Verification_styled_templateObject1(), colors.C4, colors.B1);
var List = (0,styled_components_browser_esm/* default */.ZP)(space/* default */.Z)(_templateObject2());

// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(32808);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UploadOutlined.js + 1 modules
var UploadOutlined = __webpack_require__(88484);
// EXTERNAL MODULE: ./node_modules/antd/es/upload/index.js + 20 modules
var upload = __webpack_require__(77916);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/my/company/cards/CompanyVerification.styled.ts
function CompanyVerification_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CompanyVerification_styled_templateObject() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n    flex-direction: column;\n  "
    ]);
    CompanyVerification_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyVerification_styled_templateObject1() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  padding: 1rem;\n  border: 1px solid ",
        ";\n  display: flex;\n  align-items: center;\n  ",
        ";\n"
    ]);
    CompanyVerification_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompanyVerification_styled_templateObject2() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  svg {\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n"
    ]);
    CompanyVerification_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n    margin: 1rem 0;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  margin: 0 1.5rem;\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin-bottom: 0.25rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  padding: 0 !important;\n  line-height: 1 !important;\n  height: 14px !important;\n  //cursor: pointer;\n  //color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  .ant-upload {\n    padding: 0.5rem 1rem !important;\n    text-align: left;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  :hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  //color: ",
        ";\n  //text-decoration: underline;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  color: ",
        " !important;\n  background-color: #c7c7c7 !important;\n  border-color: #c7c7c7 !important;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        "\n  color: ",
        " !important;\n  background-color: #f8c200 !important;\n  border-color: #f8c200 !important;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = CompanyVerification_styled_taggedTemplateLiteral([
        ""
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var CompanyVerification_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(CompanyVerification_styled_templateObject1(), mixins/* boxShadow */.Wn(), mixins/* borderRadius */.E0(), colors.C2, mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(CompanyVerification_styled_templateObject())));
var iconSize = 50;
var Start = styled_components_browser_esm/* default.div */.ZP.div(CompanyVerification_styled_templateObject2(), iconSize, iconSize);
var Center = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), mixins/* onMobile */.vA((0,styled_components_browser_esm/* css */.iv)(_templateObject3())));
var Title = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5(), mixins/* typography */.cp("h3"));
var CompanyVerification_styled_Description = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6(), colors.C4);
var SendVerifyCodeButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "link",
    size: "small"
})(_templateObject7(), colors.B1);
var UploadBox = (0,styled_components_browser_esm/* default */.ZP)(upload/* default.Dragger */.Z.Dragger)(_templateObject8());
var PrivacyPolicyAnchor = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(_templateObject9(), colors.B1);
var UnVerifiedButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "primary"
})(_templateObject10(), colors.B1);
var VerifyPendingButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    disabled: true
})(_templateObject11(), colors.M1);
var VerifiedButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    disabled: true
})(_templateObject12(), colors.M1);
var End = styled_components_browser_esm/* default.div */.ZP.div(_templateObject13());

;// CONCATENATED MODULE: ./src/hooks/timer.ts

var useTimer = function() {
    var initialRemainSecond = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, cycleSecond = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 60, intervalMillisecond = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000, step = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : -1;
    var ref = (0,react.useState)(initialRemainSecond), remainSecond = ref[0], setRemainSecond = ref[1];
    var timer = (0,react.useRef)();
    var setTimer = (0,react.useCallback)(function() {
        return window.setInterval(function() {
            setRemainSecond(function(draft) {
                if (draft > 0) {
                    return draft + step;
                } else {
                    window.clearInterval(timer.current);
                    return 0;
                }
            });
        }, intervalMillisecond);
    }, [
        intervalMillisecond,
        step
    ]);
    (0,react.useEffect)(function() {
        timer.current = setTimer();
        return function() {
            window.clearInterval(timer.current);
        };
    }, [
        setTimer
    ]);
    var reset = (0,react.useCallback)(function() {
        setRemainSecond(cycleSecond);
        timer.current = setTimer();
    }, [
        cycleSecond,
        setTimer
    ]);
    var hasRemain = (0,react.useMemo)(function() {
        return remainSecond > 0;
    }, [
        remainSecond
    ]);
    return {
        remainSecond: remainSecond,
        reset: reset,
        hasRemain: hasRemain
    };
};

;// CONCATENATED MODULE: ./src/pages/my/company/cards/verification_icon.svg
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgVerificationIcon = function SvgVerificationIcon(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.393 49.317a3.635 3.635 0 0 1-5.434-1.456 6.187 6.187 0 0 0-6.245-3.602 3.638 3.638 0 0 1-3.977-3.98 6.187 6.187 0 0 0-3.607-6.247 3.636 3.636 0 0 1-1.441-5.431 6.187 6.187 0 0 0 0-7.207 3.636 3.636 0 0 1 1.44-5.439 6.187 6.187 0 0 0 3.605-6.242 3.636 3.636 0 0 1 3.98-3.98 6.187 6.187 0 0 0 6.243-3.608A3.637 3.637 0 0 1 21.393.688a6.187 6.187 0 0 0 7.207 0 3.636 3.636 0 0 1 5.434 1.441 6.187 6.187 0 0 0 6.244 3.604 3.636 3.636 0 0 1 3.977 3.98 6.188 6.188 0 0 0 3.607 6.242 3.636 3.636 0 0 1 1.456 5.435 6.187 6.187 0 0 0 0 7.206 3.634 3.634 0 0 1-1.456 5.435 6.187 6.187 0 0 0-3.604 6.242 3.636 3.636 0 0 1-3.98 3.975 6.187 6.187 0 0 0-6.244 3.607 3.636 3.636 0 0 1-5.434 1.456 6.188 6.188 0 0 0-7.207 0v.006Z",
    fill: "#F8C200"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M19.546 15.154v.724a1.2 1.2 0 0 0-.56.14.557.557 0 0 0-.279.54c.033.4.158.787.365 1.13l.388.758.454.923 5.303 11.024 5.188-10.868c.265-.556.518-1.065.757-1.527l.171-.341c.224-.347.376-.734.447-1.14 0-.396-.333-.61-.998-.64h-.16v-.723h7.256v.724a1.321 1.321 0 0 0-1.203.579 8.991 8.991 0 0 0-.465.789L28.585 33.51a2.343 2.343 0 0 1-2.121 1.339h-2.676a2.344 2.344 0 0 1-2.12-1.332l-7.888-16.6a1.351 1.351 0 0 0-.579-.64 4.933 4.933 0 0 0-.851-.334l-.227-.065v-.724h7.423Z",
    fill: "#fff"
  })));
};
/* harmony default export */ var verification_icon = (SvgVerificationIcon);
;// CONCATENATED MODULE: ./src/pages/my/company/cards/CompanyVerification.tsx
function CompanyVerification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CompanyVerification_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CompanyVerification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CompanyVerification_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var CompanyVerification = function(props) {
    var children = props.children, rest = _objectWithoutProperties(props, [
        "children"
    ]);
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react.useState)(""), verifyCode = ref1[0], setVerifyCode = ref1[1];
    var ref2 = (0,react.useState)(false), sendVerifyCodeLoading = ref2[0], setSendVerifyCodeLoading = ref2[1];
    var ref3 = useTimer(), remainSecond = ref3.remainSecond, reset = ref3.reset, hasRemain = ref3.hasRemain;
    var handleSendVerifyCode = function() {
        var _ref = CompanyVerification_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSendVerifyCodeLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return (0,me/* companySendCode */.mQ)(email);
                    case 4:
                        reset();
                        message/* default.success */.ZP.success("\u9A8C\u8BC1\u7801\u53D1\u9001\u6210\u529F");
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error("send verify code for company verification, email: [".concat(email, "], error: "), _ctx.t0);
                        message/* default.error */.ZP.error("".concat(_ctx.t0.detail).concat(_ctx.t0.errors ? ". " + _ctx.t0.errors.email.join(", ") : ""));
                    case 12:
                        _ctx.prev = 12;
                        setSendVerifyCodeLoading(false);
                        return _ctx.finish(12);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8,
                    12,
                    15
                ]
            ]);
        }));
        return function handleSendVerifyCode() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,react.useState)("email"), validateBy = ref4[0], setValidateBy = ref4[1];
    var ref5 = (0,dist/* default */.ZP)("/api/profile", me/* profile */.N5), data = ref5.data, mutate = ref5.mutate;
    var status = data === null || data === void 0 ? void 0 : data.data.company_verified_status;
    var validateByEmailNode = /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        gutter: [
            16,
            16
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                sm: 24,
                md: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                    placeholder: "\u8BF7\u8F93\u5165\u4F01\u4E1A\u90AE\u7BB1",
                    value: email,
                    onChange: function(event) {
                        return setEmail(event.target.value);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                sm: 24,
                md: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                    placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
                    value: verifyCode,
                    onChange: function(event) {
                        return setVerifyCode(event.target.value);
                    },
                    suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(SendVerifyCodeButton, {
                        onClick: handleSendVerifyCode,
                        loading: sendVerifyCodeLoading,
                        disabled: hasRemain,
                        children: hasRemain ? "\u91CD\u65B0\u83B7\u53D6(".concat(remainSecond, "\u79D2)") : "\u83B7\u53D6\u9A8C\u8BC1\u7801"
                    })
                })
            })
        ]
    });
    var ref6 = (0,react.useState)([]), fileList1 = ref6[0], setFileList = ref6[1];
    var validateByFileNode = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadBox, {
                maxCount: 1,
                multiple: false,
                beforeUpload: function() {
                    return false;
                },
                fileList: fileList1,
                onChange: function(param) {
                    var file = param.file, fileList = param.fileList;
                    if (fileList.length === 0) setFileList([]);
                    else setFileList([
                        file
                    ]);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadOutlined/* default */.Z, {}),
                    " \u4E0A\u4F20\u6587\u4EF6"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyVerification_styled_Description, {
                children: "\u8BF7\u63D0\u4F9B\u98DE\u4E66\u3001\u9489\u9489\u3001\u4F01\u4E1A\u5FAE\u4FE1\u7B49\u529E\u516C\u8F6F\u4EF6\u7684\u540D\u7247\u622A\u56FE\uFF0C\u6216\u5DE5\u724C\u7167\u7247\uFF0C\u6216\u5728\u804C\u8BC1\u660E\uFF08\u9700\u624B\u5199\u4EC5\u7528\u4E8E TiDB Community \u8BA4\u8BC1\u5B57\u6837\uFF0C\u5E76\u52A0\u76D6\u4F01\u4E1A\u516C\u7AE0\uFF09\uFF1B\u4FE1\u606F\u6E05\u6670\u53EF\u89C1\uFF0C\u5185\u5BB9\u771F\u5B9E\u6709\u6548\uFF0C\u4E0D\u5F97\u505A\u4EFB\u4F55\u4FEE\u6539\uFF1B\u652F\u6301 .jpg .jpeg .bmp .png \u683C\u5F0F\uFF0C\u5927\u5C0F\u4E0D\u8D85\u8FC7 5 M\u3002"
            })
        ]
    });
    var ref7 = (0,react.useState)(false), checked = ref7[0], setChecked = ref7[1];
    var disabled = (0,react.useMemo)(function() {
        var emailValid = validateBy === "email" && email !== "" && verifyCode !== "";
        var fileValid = validateBy === "file" && fileList1.length === 1;
        return !(checked && (emailValid || fileValid));
    }, [
        checked,
        email,
        fileList1.length,
        validateBy,
        verifyCode
    ]);
    var ref8 = (0,react.useState)(false), visible = ref8[0], setVisible = ref8[1];
    var ref9 = (0,react.useState)(false), confirmLoading = ref9[0], setConfirmLoading = ref9[1];
    var handleOk = function() {
        var _ref = CompanyVerification_asyncToGenerator(runtime_default().mark(function _callee() {
            var file, errorMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setConfirmLoading(true);
                        _ctx.prev = 1;
                        _ctx.t0 = validateBy;
                        _ctx.next = _ctx.t0 === "email" ? 5 : _ctx.t0 === "file" ? 8 : 13;
                        break;
                    case 5:
                        _ctx.next = 7;
                        return (0,me/* companyVerifyByEmail */.ZX)(email, verifyCode);
                    case 7:
                        return _ctx.abrupt("break", 13);
                    case 8:
                        file = fileList1[0];
                        if (!file) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 12;
                        return (0,me/* companyVerifyByFile */.kT)(file);
                    case 12:
                        return _ctx.abrupt("break", 13);
                    case 13:
                        setVisible(false);
                        message/* default.success */.ZP.success("\u516C\u53F8\u8BA4\u8BC1\u63D0\u4EA4\u6210\u529F");
                        _ctx.next = 17;
                        return mutate();
                    case 17:
                        _ctx.next = 24;
                        break;
                    case 19:
                        _ctx.prev = 19;
                        _ctx.t1 = _ctx["catch"](1);
                        console.error("submit company verification, error: ", _ctx.t1);
                        errorMessage = Object.values(_ctx.t1.errors).map(function(value) {
                            return value.join(", ");
                        }).join(", ");
                        message/* default.error */.ZP.error("".concat(_ctx.t1.detail).concat(errorMessage !== "" ? "\uFF0C" + errorMessage : ""));
                    case 24:
                        _ctx.prev = 24;
                        setConfirmLoading(false);
                        return _ctx.finish(24);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    19,
                    24,
                    27
                ]
            ]);
        }));
        return function handleOk() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        setVisible(false);
    };
    var handleClickVerify = function() {
        var _ref = CompanyVerification_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (data === undefined || data.data.company_name === "" || data.data.job_title === "" || data.data.company_name === null || data.data.job_title === null || data.data.company_name === undefined || data.data.job_title === undefined) {
                            message/* default.error */.ZP.error("\u8BF7\u5148\u5B8C\u5584\u516C\u53F8\u4FE1\u606F");
                        } else {
                            setVisible(true);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClickVerify() {
            return _ref.apply(this, arguments);
        };
    }();
    var buttonNode;
    switch(status){
        case me/* ECompanyVerifiedStatus.unVerified */.yn.unVerified:
            {
                buttonNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(UnVerifiedButton, {
                    type: "primary",
                    onClick: handleClickVerify,
                    children: "\u7ACB\u5373\u8BA4\u8BC1"
                });
                break;
            }
        case me/* ECompanyVerifiedStatus.pending */.yn.pending:
            {
                buttonNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyPendingButton, {
                    children: "\u5BA1\u6838\u4E2D"
                });
                break;
            }
        case me/* ECompanyVerifiedStatus.verified */.yn.verified:
            {
                buttonNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedButton, {
                    children: "\u5DF2\u8BA4\u8BC1"
                });
                break;
            }
        default:
            {
                buttonNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyPendingButton, {
                    loading: true,
                    children: "\u52A0\u8F7D\u4E2D"
                });
                break;
            }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyVerification_styled_Container, _objectSpread({}, rest, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Start, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(verification_icon, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Center, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "\u8BA4\u8BC1\u516C\u53F8\u4FE1\u606F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyVerification_styled_Description, {
                                children: "\u9996\u6B21\u8BA4\u8BC1\u6210\u529F\u53EF\u83B7\u5F97 100 \u79EF\u5206\u5956\u52B1\uFF1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyVerification_styled_Description, {
                                children: "\u66F4\u65B0\u8BA4\u8BC1\u4FE1\u606F\uFF0C\u5BA1\u6838\u901A\u8FC7\u540E\u53EF\u83B7\u5F97 50 \u79EF\u5206\u5956\u52B1\u3002"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(End, {
                        children: buttonNode
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                visible: visible,
                title: "\u8BA4\u8BC1\u4FE1\u606F",
                onOk: handleOk,
                onCancel: handleCancel,
                okText: "\u63D0\u4EA4",
                cancelText: "\u53D6\u6D88",
                confirmLoading: confirmLoading,
                okButtonProps: {
                    disabled: disabled
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
                    size: 16,
                    direction: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_radio/* default.Group */.ZP.Group, {
                            value: validateBy,
                            onChange: function(event) {
                                return setValidateBy(event.target.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                                    value: "email",
                                    children: "\u4F01\u4E1A\u90AE\u7BB1\u8BA4\u8BC1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                                    value: "file",
                                    children: "\u98DE\u4E66\u3001\u9489\u9489\u3001\u4F01\u4E1A\u5FAE\u4FE1\u3001\u5DE5\u724C\u3001\u5728\u804C\u8BC1\u660E"
                                })
                            ]
                        }),
                        validateBy === "email" ? validateByEmailNode : validateByFileNode,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_checkbox/* default */.Z, {
                            checked: checked,
                            onChange: function(event) {
                                return setChecked(event.target.checked);
                            },
                            children: [
                                "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicyAnchor, {
                                    href: "/docs/verification-agreement",
                                    children: "\u300A\u8BA4\u8BC1\u670D\u52A1\u534F\u8BAE\u300B"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var cards_CompanyVerification = (CompanyVerification);

;// CONCATENATED MODULE: ./src/pages/my/company/Verification.component.tsx
function Verification_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Verification_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Verification_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Verification_component_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Verification_component_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Verification_component_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var Verification = function(props) {
    //function Verification.component(props: IProps) {
    var children = props.children, className = props.className, rest = Verification_component_objectWithoutProperties(props, [
        "children",
        "className"
    ]);
    var data = (0,dist/* default */.ZP)("/api/profile", me/* profile */.N5).data;
    var status = data === null || data === void 0 ? void 0 : data.data.company_verified_status;
    var descriptionNode;
    switch(status){
        case me/* ECompanyVerifiedStatus.verified */.yn.verified:
            {
                descriptionNode = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "\u5982\u60A8\u7684\u516C\u53F8\u4FE1\u606F\u53D1\u751F\u53D8\u5316\uFF0C\u53EF\u66F4\u65B0\u4E0A\u65B9\u4FE1\u606F\u540E\uFF0C\u91CD\u65B0\u7533\u8BF7\u8BA4\u8BC1"
                });
                break;
            }
        default:
            {
                descriptionNode = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "\u8BA4\u8BC1\u7ED3\u679C\u4F1A\u901A\u8FC7 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                            href: "/private-messages",
                            children: "\u7CFB\u7EDF\u901A\u77E5"
                        }),
                        " \u53CA\u65F6\u544A\u77E5\uFF0C\u8BF7\u6CE8\u610F\u67E5\u770B"
                    ]
                });
                break;
            }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, Verification_component_objectSpread({}, rest, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Verification_styled_Description, {
                children: descriptionNode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cards_CompanyVerification, {})
            })
        ]
    }));
};
/* harmony default export */ var Verification_component = (Verification);

;// CONCATENATED MODULE: ./src/pages/my/company/index.page.js
function index_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function index_page_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                index_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                index_page_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}













var PageContent = function(param) {
    var title = param.title;
    var ref = (0,react.useContext)(context/* AuthContext */.Vo), login = ref.login, isAnonymous = ref.isAnonymous, isLoggedIn = ref.isLoggedIn;
    var ref1 = (0,dist/* default */.ZP)(isLoggedIn && "operation.fetchRedDots"), redDotsResp = ref1.data;
    var meData = (0,react.useContext)(context/* MeContext */.io).meData;
    var mutate = (0,dist/* useSWRConfig */.kY)().mutate;
    var redDots = utils/* redDots.transformRespToMap */.a_.transformRespToMap(redDotsResp);
    (0,react.useEffect)(function() {
        index_page_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!redDots.companyInfo) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 3;
                        return operation.setRedDotRead("company-info");
                    case 3:
                        mutate("operation.fetchRedDots");
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        redDots.companyInfo,
        mutate
    ]);
    if (isAnonymous) {
        login();
        return null;
    }
    if (!meData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLoader */.wY, {});
    }
    var titleNode = /*#__PURE__*/ (0,jsx_runtime.jsxs)(space/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBadge, {
                children: "\u975E\u516C\u5F00"
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        title: titleNode,
        children: [
            redDots.companyInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                type: "info",
                showIcon: true,
                message: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: "\u5B8C\u6210\u516C\u53F8\u4FE1\u606F\u586B\u5199\u53EF +20 \u79EF\u5206"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_component, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Verification_component, {})
        ]
    });
};
var Page = function() {
    var title = "\u516C\u53F8\u4FE1\u606F";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent, {
                title: title
            })
        ]
    });
};
/* harmony default export */ var index_page = (Page);


/***/ }),

/***/ 35703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/my/layout/layout.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 2rem 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  font-weight: bold;\n  color: ",
        ";\n  padding: 0.8rem 1rem;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n\n  &,\n  .ant-form {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* responsive */.jW());
var Main = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), colors.T2);
var Title = styled_components_browser_esm/* default.h1 */.ZP.h1(_templateObject2(), mixins/* typography */.cp("p1"), mixins/* reset */.mc(), colors.F1, colors.T2);
var Content = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), mixins/* typography */.cp("p2"));

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/antd/es/badge/index.js + 4 modules
var badge = __webpack_require__(63922);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/my/layout/menu/menu.styled.js
function menu_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styled_templateObject() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  background: ",
        ";\n  list-style: none;\n  border: 1px solid ",
        ";\n"
    ]);
    menu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styled_templateObject1() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      cursor: default;\n      border-left: 3px solid ",
        ";\n      background: ",
        " !important;\n    "
    ]);
    menu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_styled_templateObject2() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  justify-content: space-between;\n  padding: 0 1rem;\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    menu_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var menu_styled_Container = styled_components_browser_esm/* default.ul */.ZP.ul(menu_styled_templateObject(), mixins/* reset */.mc(), mixins/* typography */.cp("p2"), colors.M1, colors.T2);
var Item = styled_components_browser_esm/* default.li */.ZP.li(menu_styled_templateObject2(), mixins/* flexVerticalCenter */.VL(), mixins/* verticalLineMiddle */.XK("2.5rem"), colors.M2, function(props) {
    return props.isActive && (0,styled_components_browser_esm/* css */.iv)(menu_styled_templateObject1(), colors.B1, colors.M1);
});

// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/utils/index.js + 4 modules
var utils = __webpack_require__(59914);
;// CONCATENATED MODULE: ./src/pages/my/layout/menu/Menu.component.js








var Menu = function() {
    var router = (0,next_router.useRouter)();
    var isLoggedIn = (0,react.useContext)(context/* AuthContext */.Vo).isLoggedIn;
    var ref = (0,dist/* default */.ZP)(isLoggedIn && "operation.fetchRedDots"), redDotsResp = ref.data;
    var redDots = utils/* redDots.transformRespToMap */.a_.transformRespToMap(redDotsResp);
    var asPath = router.asPath;
    var genPath = function(path) {
        return "/my/".concat(path);
    };
    var profilePath = genPath("profile");
    var companyPath = genPath("company");
    var settingsPath = genPath("settings");
    var onClick = function(path) {
        return function() {
            router.push(path);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                isActive: asPath === profilePath,
                onClick: onClick(profilePath),
                children: "\u4E2A\u4EBA\u4FE1\u606F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                isActive: asPath === companyPath,
                onClick: onClick(companyPath),
                children: [
                    "\u516C\u53F8\u4FE1\u606F ",
                    redDots.companyInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                        count: "+20\u79EF\u5206"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                isActive: asPath === settingsPath,
                onClick: onClick(settingsPath),
                children: "\u8D26\u53F7\u8BBE\u7F6E"
            })
        ]
    });
};
/* harmony default export */ var Menu_component = (Menu);

;// CONCATENATED MODULE: ./src/pages/my/layout/menu/index.js


// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
;// CONCATENATED MODULE: ./src/pages/my/layout/Layout.component.js







var Layout = function(param) {
    var children = param.children, title = param.title;
    var setIsAuthRequired = (0,react.useContext)(context/* AuthContext */.Vo).setIsAuthRequired;
    (0,react.useEffect)(function() {
        setIsAuthRequired(true);
        return function() {
            return setIsAuthRequired(false);
        };
    }, [
        setIsAuthRequired
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* CoreLayout */.N, {
            hasMargin: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    gutter: [
                        32,
                        32
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 24,
                            sm: 8,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_component, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 24,
                            sm: 16,
                            md: 18,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                        children: children
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/my/layout/index.js



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,469,7781,8150,9774,2888,179], function() { return __webpack_exec__(84678); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);